"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Setpointabweichung"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.55,1.58v5h3.88a2.71,2.71,0,0,1,1.17-.35V1.58Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.59",
    y: "1.58",
    width: "5.05",
    height: "4.96",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.27,19.91Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.63",
    y: "15.28",
    width: "5.05",
    height: "4.96",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.25,0H0V8.12H8.25ZM6.64,6.54h-5v-5H6.64Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.77,7.1A1.81,1.81,0,0,1,22,7.62,1.81,1.81,0,0,0,20.77,7.1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.43,6.54H15.55v-5H20.6V6.19l.17,0a2.81,2.81,0,0,1,1.44.41V0H13.94V8.12h4.22A2.67,2.67,0,0,1,19.43,6.54Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,21.82H8.25V13.7H0Zm1.65-6.54H6.68v5h-5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.13",
    width: "1.93",
    height: "8.12",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.04",
    y: "10.92",
    width: "11",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.41,12.38a.36.36,0,0,1,.36-.35.36.36,0,0,0-.36.35v.37h0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "-0.02",
    y: "9.09",
    width: "3.92",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.62",
    y: "15.47",
    width: "6.06",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.26,19.92l-.13.07.13-.07Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7,20.83a1.26,1.26,0,0,1,.05-.33,1.26,1.26,0,0,0-.05.33,1.05,1.05,0,0,0,.65,1A1.05,1.05,0,0,1,19.7,20.83Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.41,19.84V15.47h0v4.37l-.14.07h0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.71,19.92H13.9v1.9h2.84a4.08,4.08,0,0,1-.14-1A4,4,0,0,1,16.71,19.92Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.9,20.06a3.18,3.18,0,0,0-.73-1.35,3.68,3.68,0,0,0-.6-.51V8.86a1.57,1.57,0,0,0-.15-.68,1.77,1.77,0,0,0-.21-.32A1.46,1.46,0,0,0,22,7.62a1.79,1.79,0,0,0-2.88.5,1.65,1.65,0,0,0-.18.74V18.2a3.68,3.68,0,0,0-.6.51,3.16,3.16,0,0,0-.68,1.21,3.11,3.11,0,0,0-.16.91A3.25,3.25,0,0,0,20.77,24,3.29,3.29,0,0,0,22,23.75a3.2,3.2,0,0,0,1-.68A3.09,3.09,0,0,0,24,20.83,2.86,2.86,0,0,0,23.9,20.06ZM21.19,21.8l-.08,0a.86.86,0,0,1-.68,0l-.08,0a1.05,1.05,0,0,1-.65-1,1.26,1.26,0,0,1,.05-.33,1.06,1.06,0,0,1,.38-.51l.13-.07h0l.14-.07V12.38a.36.36,0,0,1,.72,0v7.46a1.32,1.32,0,0,1,.29.15,1.25,1.25,0,0,1,.23.23,1.06,1.06,0,0,1,.2.61A1,1,0,0,1,21.19,21.8Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.77,21.89a1,1,0,0,0,.34-.07h-.68A1,1,0,0,0,20.77,21.89Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.27,19.92h0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.05,23.07a3.2,3.2,0,0,1-1,.68A3.2,3.2,0,0,0,23.05,23.07Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.57,18.2a3.68,3.68,0,0,1,.6.51,3.68,3.68,0,0,0-.6-.51V8.86a1.57,1.57,0,0,0-.15-.68,1.57,1.57,0,0,1,.15.68Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.38,18.71a3.16,3.16,0,0,0-.68,1.21h0A3.16,3.16,0,0,1,18.38,18.71Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,23.75a3.29,3.29,0,0,1-1.26.25A3.29,3.29,0,0,0,22,23.75Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "21.13",
    y: "12.75",
    height: "2.71",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.05,23.07A3.09,3.09,0,0,0,24,20.83a2.86,2.86,0,0,0-.1-.77,2.86,2.86,0,0,1,.1.77A3.09,3.09,0,0,1,23.05,23.07Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.77,12a.36.36,0,0,1,.36.35v.37h0v-.37A.36.36,0,0,0,20.77,12Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.13,19.84a1.32,1.32,0,0,1,.29.15,1.32,1.32,0,0,0-.29-.15V15.47h0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.7,19.92a3.11,3.11,0,0,0-.16.91,3.11,3.11,0,0,1,.16-.91Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.19,21.8a1,1,0,0,0,.66-1,1.06,1.06,0,0,0-.2-.61,1.06,1.06,0,0,1,.2.61A1,1,0,0,1,21.19,21.8Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;